<template>
    <span v-show="showscroltop" @click="goTop" class="scrollUp1"><i class="fa fa-angle-up"></i></span>
</template>

<script>
    export default {
        name: "ScrollUp",
        data: () =>({
            showscroltop: false,
            scroltimeout: null,
        }),
        methods:{
            handeslrol(){
                 if (this.scroltimeout) return;
                 this.scroltimeout= setTimeout(() =>{
                 this.showscroltop=window.scrollY > 400;
                 clearTimeout(this.scroltimeout);
                 this.scroltimeout=0;
         },170);
         },
            goTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },
        mounted() {
            document.addEventListener('scroll',this.handeslrol);
        },
        destroyed() {
            document.removeEventListener('scroll',this.handeslrol);
        }

    }
</script>

<style scoped>
    .scrollUp1 {
        position: fixed;
        bottom: 65px;
        right: 30px;
        text-align: center;
        cursor: pointer;
        color: #fff;
        width: 40px;
        height: 40px;
        font-weight: 600;
        text-transform: uppercase;
        background: #1f4d81;
        z-index: 999;
        font-size: 30px;
    }
</style>
